interface FloatingAlertProps {
	hasCloseButton?: boolean;
	hasIcon?: boolean;
}

const FLOATING_ALERT_DEFAULT_PROPS = {
	hasCloseButton: true,
	hasIcon: false,
} satisfies Required<FloatingAlertProps>;

export {
	FLOATING_ALERT_DEFAULT_PROPS,
	type FloatingAlertProps,
};
